export default __webpack_public_path__ + "4e08708028117a86619e1cd6dae6a55a.woff";